export default "__VITE_ASSET__B0UKn390__";